import { cx } from '@libs/classnames';
import { CapsuleButton } from '@ui/components/CapsuleButton';
import { Loader } from '@ui/components/Loader';
import { Placeholder } from '@ui/components/Placeholder/Placeholder';

import { Achievement } from '@features/shared/api/typings';
import { PlayerAchievementsListItem } from '@features/user/ui/PlayerAchievementsListItem/PlayerAchievementsListItem';

import styles from './PlayerAchievementsListFull.module.css';

type Props = {
  className?: string;
  achievements?: Achievement[];
  onLoadMore?: () => void;
  onItemClick: (achievement: Achievement) => void;
  isLoading?: boolean;
};
export function PlayerAchievementsListFull({
  className,
  achievements,
  onLoadMore,
  onItemClick,
  isLoading,
}: Props) {
  return (
    <div className={cx(styles.achievements, className)}>
      <div className={styles.list}>
        {achievements?.map((a) => (
          <PlayerAchievementsListItem
            key={a.tournamentCertificate?.tournamentTitle}
            achievement={a}
            preset="m"
            onClick={onItemClick}
          />
        ))}
      </div>

      {achievements && !achievements.length && <Placeholder>Пока нет достижений</Placeholder>}

      {onLoadMore && (
        <CapsuleButton preset="gray" size="16m-40" onClick={onLoadMore}>
          Показать еще
        </CapsuleButton>
      )}

      {isLoading && <Loader centered />}
    </div>
  );
}
